<ui-card [loading]="isLoading">
    <app-segment-header title="time-off-v3.policyComponents.basicInformationCard.header"></app-segment-header>
    <div class="flex col">
        <mat-form-field class="restricted-width">
            <mat-label>{{ 'time-off-v3.policyComponents.basicInformationCard.policyName' | translate }}</mat-label>
            <input
                name="policyName"
                type="text"
                placeholder="{{ 'time-off-v3.policyComponents.basicInformationCard.eg2Weeks' | translate }}"
                required
                matInput
                [(ngModel)]="timeOffPolicy.name"
            />
            <mat-hint>{{
                'time-off-v3.policyComponents.basicInformationCard.onlyAdminsOrPeopleWithPolicyEdit' | translate
            }}</mat-hint>
        </mat-form-field>

        <mat-form-field class="restricted-width margin-top-2">
            <mat-label appRemoveAriaOwns>{{
                'time-off-v3.policyComponents.basicInformationCard.timeOffType' | translate
            }}</mat-label>
            <mat-select
                name="timeOffTypeField"
                #timeOffTypeField="ngModel"
                placeholder="{{ 'time-off-v3.timeOffTypes' | translate }}"
                required
                [ngModel]="timeOffPolicy.timeOffTypeId"
                (ngModelChange)="onTimeOffTypeChange($event)"
                [disabled]="timeOffTypeDisabled"
            >
                <mat-option *ngFor="let timeOffType of timeOffTypes" [value]="timeOffType.id">{{
                    timeOffType.name
                }}</mat-option>
                <mat-option [value]="-1"
                    ><mat-icon svgIcon="plus"></mat-icon
                    >{{
                        'time-off-v3.policyComponents.basicInformationCard.createNewTypeOfTimeOff' | translate
                    }}</mat-option
                >
            </mat-select>
            <mat-hint>{{
                'time-off-v3.policyComponents.basicInformationCard.timeOffTypeCantBeChangedOnceEmployeesAreAssigned'
                    | translate
            }}</mat-hint>
            <mat-error *ngIf="timeOffTypeField.invalid">{{ timeOffTypeField.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="restricted-width margin-top-2">
            <mat-label appRemoveAriaOwns>{{
                'time-off-v3.policyComponents.basicInformationCard.approvalFlow' | translate
            }}</mat-label>
            <mat-select
                name="approvalFlow"
                #approvalFlow="ngModel"
                [(ngModel)]="timeOffPolicy.timeOffApprovalFlowId"
                placeholder="{{ 'time-off-v3.approvalFlow' | translate }}"
                required
                (ngModelChange)="onApprovalFlowChange($event)"
            >
                <mat-option *ngFor="let approvalFlow of timeOffApprovalFlows" [value]="approvalFlow.id">{{
                    approvalFlow.name
                }}</mat-option>
            </mat-select>
            <mat-hint>{{
                'time-off-v3.policyComponents.basicInformationCard.chooseFromDefaultApprovalFlows' | translate
            }}</mat-hint>
            <mat-error *ngIf="approvalFlow.invalid">{{ approvalFlow.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</ui-card>
